import React from 'react';

import css from './BalancePage.css';
import { SectionRewards as Rewards } from '../LandingPage/sectionsPricing';

export const RewardsTab = () => {
    return (
        <section className={css.container}>
            <Rewards showSlider={false}>
                <Rewards.Header>
                    <header className={css.header}>
                        <p className={css.subHeading}>Deine Rewards</p>
                    </header>
                </Rewards.Header>

                <Rewards.Tabs />
                <Rewards.Content
                    rootClassName={css.rewardsRoot}
                    cardClassName={css.cardContainer}
                />
            </Rewards>
        </section>
    );
};
